export const reduxName = 'i18n';
export const url = './locales';